import config from '@config';

export const getDeepLink = (path = '') => {
  const scheme = config.deepLinkURL;

  return `${scheme}://${path}`;
};
